import { get, writable } from "svelte/store";
import {
  fetchCartWidgetItem,
  updateCartProductsForInventory,
} from "@retailer/svelte/CartWidget/v2/Services/CartItemRequestService";

import type {
  CartItemResponse,
  CartProductUpdateParams,
} from "@retailer/svelte/CartWidget/v2/Services/CartItemRequestService";

const initialStoreValue: { inventoryItems: Record<number, CartItemResponse> } = {
  inventoryItems: {},
};

const _store = writable(initialStoreValue);

const { subscribe, update, set } = _store;

export const InventoryItemStore = {
  subscribe,
  update,
  set,
  refreshInventoryItemsByAssociation,

  fetchInventoryItem: async (inventoryId: number, stockSiteId: string | null = null) => {
    try {
      const inventoryItem = await fetchCartWidgetItem(inventoryId, stockSiteId);
      update(store => {
        store.inventoryItems[inventoryId] = inventoryItem;
        return store;
      });
      return { inventoryItem, loaded: true };
    } catch (e) {
      console.log(e);
      return { inventoryItem: null, loaded: true };
    }
  },

  addToCart: async (inventoryId: number, cartProduct: CartProductUpdateParams) => {
    const inventoryItem = await updateCartProductsForInventory(inventoryId, cartProduct);
    update(store => {
      store.inventoryItems[inventoryId] = inventoryItem;
      return store;
    });
  },
};

function refreshInventoryItemsByAssociation(
  id: number,
  type: "distributor" | "product_line" = "distributor",
) {
  Object.values(get(_store).inventoryItems)
    .filter(inventoryItem => {
      switch (type) {
        case "product_line":
          return inventoryItem.product_summary.product_line_id === id;
        default:
          return inventoryItem.distributor_summary.id == id;
      }
    })
    .map(inventoryItem => inventoryItem.inventory_id)
    .forEach(id => InventoryItemStore.fetchInventoryItem(id));
}
